/**
 * @fileoverview Week grid, time column, and day columns for CustomCalendar.
 * @module components/CustomCalendar/CustomCalendarGrid
 */
import styles from "./CustomCalendar.module.css";
import { isCurrentTime, isToday } from "./customCalendarUtils.js";
import CustomCalendarSlot from "./CustomCalendarSlot.jsx";

const CustomCalendarTimeColumn = ({ timeSlots, hourLabels, cellsPerHour, t }) => (
  <div className={styles.timeColumn}>
    <div className={styles.timeHeader}>{t("pages.viewAppointments.time")}</div>
    {timeSlots.map((slot) => {
      const currentTimePosition = isCurrentTime(slot);
      const isCurrentHour = new Date().getHours() === slot.hour;
      const hourLabel = hourLabels.find((label) => label.hour === slot.hour);
      const shouldShowHourLabel = slot.isFirstCellOfHour;

      return (
        <div
          key={`${slot.hour}-${slot.minute}-${slot.cellIndex}`}
          className={`${styles.timeSlot} ${
            isCurrentHour ? styles.currentTime : ""
          } ${!slot.isValid ? styles.invalidDurationSlot : ""}`}
          data-current-minute={
            currentTimePosition !== false ? currentTimePosition : null
          }
          style={{
            height: `${60 / cellsPerHour}px`,
          }}
        >
          {isCurrentHour && shouldShowHourLabel ? (
            <span className={styles.currentTimeLabel}>
              {hourLabel?.label || ""}
            </span>
          ) : shouldShowHourLabel ? (
            hourLabel?.label || ""
          ) : (
            ""
          )}
        </div>
      );
    })}
  </div>
);

const CustomCalendarDayColumn = ({
  date,
  dayIndex,
  language,
  timeSlots,
  ...slotProps
}) => (
  <div className={styles.dayColumn}>
    <div
      className={`${styles.dayHeader} ${isToday(date) ? styles.today : ""}`}
    >
      <div className={styles.dayName}>
        {date.toLocaleDateString(language, { weekday: "long" })}
      </div>
      <div className={styles.dayNumber}>{date.getDate()}</div>
    </div>
    {timeSlots.map((slot, slotIndex) => (
      <CustomCalendarSlot
        key={`${dayIndex}-${slot.hour}-${slot.minute}-${slot.cellIndex}`}
        date={date}
        slot={slot}
        slotIndex={slotIndex}
        timeSlots={timeSlots}
        {...slotProps}
      />
    ))}
  </div>
);

const CustomCalendarGrid = ({
  calendarGridRef,
  weekDates,
  timeSlots,
  hourLabels,
  cellsPerHour,
  language,
  t,
  ...slotProps
}) => (
  <div className={styles.calendarGrid} ref={calendarGridRef}>
    <CustomCalendarTimeColumn
      timeSlots={timeSlots}
      hourLabels={hourLabels}
      cellsPerHour={cellsPerHour}
      t={t}
    />
    {weekDates.map((date, dayIndex) => (
      <CustomCalendarDayColumn
        key={dayIndex}
        date={date}
        dayIndex={dayIndex}
        language={language}
        timeSlots={timeSlots}
        cellsPerHour={cellsPerHour}
        t={t}
        {...slotProps}
      />
    ))}
  </div>
);

export default CustomCalendarGrid;
